export const colors = {
  seasonalSpike: {
    background: '#0DA8EA1A',
    font: '#0DA8EA',
  },
  lightningDeal: {
    background: '#7E57C21A',
    font: '#7E57C2',
  },
  lineColors: [
    '#6BD03B',
    '#FF4142',
    '#FFBB28',
    '#42E7FF',
    '#431C53',
    '#541E1B',
    '#0088FE',
    '#D03B6B',
    '#4142FF',
    '#BB28FF',
    '#E7FF42',
    '#1C5343',
    '#1E1B54',
    '#88FE00',
  ],
  lineGlobal: '#0147FF',
};

export const boxOnLineWidth = 28;

export const referenceLineOptions = {
  strokeWidth: 2,
  isFront: false,
};

export const lineChartOptions = {
  height: 400,
  width: 500,
  margin: {
    bottom: 20,
    left: 10,
    right: 35,
    top: 50,
  },
};
